import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useFields } from './fields';
import { CreateUpdateContainer } from '../../components/CreateUpdateContainer/CreateUpdateContainer';
import { useAuthContext } from '../../contexts/AuthContext';

export const CreateUpdateSupervisionPrice = ({ purpose }) => {
  const { t } = useTranslation();
  const { fields, isFieldsLoading, base64 } = useFields();
  const { user, setUser } = useAuthContext();

  const config = {
    onGetResource: {
      setFields: (data) => ({
        ...data,
        date_of_birth: data.date_of_birth && dayjs(data.date_of_birth)
      })
    },
    onUpdateResource: {
      setBody: (data) => {
        if (data._id === user._id) setUser({ ...user, ...data });
        return {
          ...data,
          ...(base64 ? { photo: base64 } : {})
        };
      }
    }
  };

  return (
    <CreateUpdateContainer
      fields={fields}
      fieldsCardTitle={t('supervisionprices.show.principal_info')}
      fieldsCardIcon="euro"
      loadingFields={isFieldsLoading}
      purpose={purpose}
      baseUrl="supervisionprices"
      resource="supervisionprices"
      config={config}
    />
  );
};

CreateUpdateSupervisionPrice.propTypes = {
  purpose: PropTypes.string.isRequired
};
